export function pushGTM(eCat = '', eAct = '', eLab = '') {
    try {
        dataLayer.push({
            'event':         'gaEvent',
            'gaEventData':   {
                'eCat': eCat,
                'eAct': eAct,
                'eLab': eLab
            },
            'eventCallback': function () {
                dataLayer.push({ 'gaEventData': undefined });
            }
        });
    } catch (e) {

    }
}

export function pushVirtualPage(url = '', title = '') {
    try {
        dataLayer.push({
            'event':                  'gaVirtualPageview',
            'gaVirtualPageviewUrl':   url,
            'gaVirtualPageviewTitle': title || document.title
        });
    } catch (e) {

    }
}



// WEBPACK FOOTER //
// ./src/helpers/gtm.js